"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listProvinceTree = listProvinceTree;
exports.listProvince = listProvince;
exports.createProvince = createProvince;
exports.all = all;
exports.updateProvince = updateProvince;
exports.deleteProvince = deleteProvince;
exports.readProvince = readProvince;

var _request = _interopRequireDefault(require("@/utils/request"));

function listProvinceTree(query) {
  return (0, _request.default)({
    url: '/franProvince/provinceTree',
    method: 'get',
    params: query
  });
}

function listProvince(query) {
  return (0, _request.default)({
    url: '/franProvince/list',
    method: 'get',
    params: query
  });
}

function createProvince(data) {
  return (0, _request.default)({
    url: '/franProvince/create',
    method: 'post',
    data: data
  });
}

function all(data) {
  return (0, _request.default)({
    url: '/channel/all',
    method: 'get'
  });
}

function updateProvince(data) {
  return (0, _request.default)({
    url: '/franProvince/update',
    method: 'post',
    data: data
  });
}

function deleteProvince(data) {
  return (0, _request.default)({
    url: '/franProvince/delete',
    method: 'post',
    data: data
  });
}

function readProvince(query) {
  return (0, _request.default)({
    url: '/franProvince/read',
    method: 'get',
    params: query
  });
}